<template>
  <div>
    <vue-snotify></vue-snotify>
    <!-- Header -->
    <div class="header bg-gradient-info py-7">
      <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <img class="pb-5 mr-2 logo-img" src="img/brand/green.png" />
              <h1 class="text-dark">Welcome!</h1>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-color border5 mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form
                  class="pt-3"
                  role="form"
                  @submit.prevent="handleSubmit(onSubmit)"
                >
                  <label class="form-control-label">Enter Email Address</label>
                  <base-input
                    alternative
                    class="mb-2"
                    name="Email"
                    :rules="{ required: true }"
                    prepend-icon="ni ni-email-83"
                    placeholder="Email"
                    v-model="model.email"
                  >
                  </base-input>

                  <label class="form-control-label">Enter Password</label>
                  <base-input
                    alternative
                    class="mb-3"
                    name="Password"
                    :rules="{ required: true, min: 6 }"
                    prepend-icon="ni ni-lock-circle-open"
                    type="password"
                    placeholder="Password"
                    v-model="model.password"
                  >
                  </base-input>

                  <div class="text-center pt-3">
                    <base-button
                      type="primary"
                      size="lg"
                      native-type="submit"
                      block
                      class="my-4"
                      >Sign in</base-button
                    >
                  </div>
                </b-form>
              </validation-observer>
              <b-row class="mt-3">
                <b-col cols="6">
                  <router-link to="/forgetpassword" class="text-primary"
                    ><small>Forgot password?</small></router-link
                  >
                </b-col>
                <b-col cols="6" class="text-right"> </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import BaseInput from "../../components/Inputs/BaseInput.vue";
import { mapActions, mapState } from "vuex";
export default {
  components: {
    BaseInput,
  },
  data() {
    return {
      model: {
        email: "",
        password: "",
        rememberMe: false,
      },
    };
  },
  methods: {
    ...mapActions("user", ["login"]),
    onSubmit() {
      const userdata = {
        username: this.model.email,
        password: this.model.password,
        remember_me: this.model.rememberMe,
      };
      this.login(userdata).then((data) => {
        if (data.data.errors) {
          this.$refs.formValidator.setErrors(data.data.errors);
        }
      });
    },
  },
};
</script>

<style scoped>
.logo-img {
  width: 150px;
  height: auto;
}

.bg-color {
  background-color: rgb(241, 241, 241) !important;
}
</style>
